import React from 'react';
import PasswordInput from 'components/forms/PasswordInput/PasswordInput';
import BlazeTable from 'components/blazeTable/BlazeTable';
import { BlazeTableOptions } from 'components/blazeTable/BlazeTable.types';
import i18n from '../../../i18n';
import Row from 'react-bootstrap/Row';
import BzmIcon from '../../../components/icons/BzmIcon';
import _ from 'lodash';
import { AliasImport, hasPassword } from './CertificateDetailsModal';

interface AliasesTableProps {
  aliases: AliasImport[];
  onUpdateAliasPassword: (aliasName: string, aliasPassword: string) => void;
}

const AliasesTable = (props: AliasesTableProps) => {
  const { onUpdateAliasPassword } = props;
  const aliases = props.aliases.slice().sort((a, b) => a.name.localeCompare(b.name));

  const tableOptions: BlazeTableOptions = {
    pageable: false,
    tableName: 'Aliases',
    columnDef: [
      {
        header: i18n.t('transactions:aliasesTable.alias'),
        accessor: 'name',
        cellComponent: (alias: AliasImport) => {
          return (
            <Row>
              <span className={'mt-1 ml-3'}>
                {alias.type === 'KEY_PAIR' ? (
                  <BzmIcon variant={'icon-bzm-key'} className={'icon-xs text-attention'} onClick={() => _.noop()} />
                ) : (
                  <BzmIcon variant={'icon-bzm-license'} className={'icon-xs text-danger'} onClick={() => _.noop()} />
                )}
              </span>
              <span title={alias.name} className={'ml-3 text-truncate'} style={{ maxWidth: '75%' }}>
                {alias.name}
              </span>
            </Row>
          );
        },
      },
      {
        header: i18n.t('transactions:aliasesTable.type'),
        accessor: 'type',
        cellComponent: (alias: AliasImport) => <> {alias.type === 'KEY_PAIR' ? 'Alias (Key Pair)' : 'Certificate'}</>,
      },
      {
        header: i18n.t('transactions:aliasesTable.password'),
        accessor: 'password',
        cellComponent: (alias: AliasImport) => {
          if (alias.type === 'KEY_PAIR') {
            return (
              <Row>
                <PasswordInput
                  disabled={alias.accessGranted}
                  onChange={password => onUpdateAliasPassword(alias.name, password)}
                  value={hasPassword(alias.password) ? atob(alias.password) : ''}
                  showRevealOption={false}
                  className={alias.isValid !== true ? 'is-invalid' : undefined}
                  style={alias.isValid !== true ? { borderColor: '#de1b1b' } : undefined}
                />
                <span className={'ml-3 mt-3'}>
                  {alias.accessGranted !== true ? (
                    alias.isValid !== true &&
                    !_.isNil(alias.password) && (
                      <BzmIcon
                        title={i18n.t('common:sslConfig.aliases.wrongPassword')}
                        variant={'icon-bzm-danger'}
                        className={'icon-xs text-danger'}
                        onClick={() => _.noop()}
                      />
                    )
                  ) : (
                    <BzmIcon
                      title={i18n.t('common:sslConfig.aliases.correctPassword')}
                      variant={'icon-bzm-checkmark'}
                      className={'icon-xs text-success'}
                      onClick={() => _.noop()}
                    />
                  )}
                </span>
              </Row>
            );
          } else {
            return <> n/a </>;
          }
        },
        cellClass: 'flex-table-col-overflow-visible',
      },
    ],
    showRowExpander: false,
    selectable: false,
  };

  return <BlazeTable options={tableOptions} data={aliases} showPageSizeDropdown={false} />;
};

export default AliasesTable;
